import AuthService from "./AuthService";
import ApiService from "./ApiService";

class PartnerManufacturerShowcasesService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = "ru";
        this._showcasesUrl = "/partner-manufacturer-showcases";
        this._createPartnerUrl = "/partner-manufacturer-showcases/create-partner";
        this._detailsUrl = "/partner-manufacturer-showcases/details";
        this._tableDataUrl = "/partner-manufacturer-showcases/table-data";
        this._updateUrl = "/partner-manufacturer-showcases/update";
    }

    getBaseHeaders() {
        const langHeader = this.getLangHeader();
        const authHeader = this._authService.getAuthHeader();

        return { ...authHeader, ...langHeader };
    }

    getShowcases(params) {
        return this.postResource(this._showcasesUrl, params, this.getBaseHeaders());
    }

    createPartner(data) {
        return this.postResource(this._createPartnerUrl, data, this.getBaseHeaders());
    }

    getDetails(id) {
        return this.postResource(this._detailsUrl, { id }, this.getBaseHeaders());
    }

    update(data) {
        return this.postResource(this._updateUrl, data, this.getBaseHeaders());
    }

    getTableData() {
        return this.postResource(this._tableDataUrl, {}, this.getBaseHeaders());
    }
}

const service = new PartnerManufacturerShowcasesService(AuthService);

export default service;
